import { BasePagedSearchCriteria } from "./BaseSearchCriteria";

export interface ReportTemplateSearchCriteria extends BasePagedSearchCriteria{

    name?:string;
    type?:string;
}

export const REPORT_TEMPLATE_SEARCH_CRITERIA_KEY = 'ReportTemplateSearchCriteria';